import React from 'react';
import { Link } from 'react-router-dom';

const IconBell = () => (
  <svg viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
    <path d="M13.5 10V7.5a4.5 4.5 0 00-9 0V10l-1.5 2h12l-1.5-2z"/>
    <path d="M7 14a2 2 0 004 0"/>
  </svg>
);

const IconSlash = () => (
  <svg viewBox="0 0 8 14" width="8" height="14" fill="none">
    <line x1="6" y1="1" x2="2" y2="13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

export default function ExamHeader({ breadcrumbs = [], actions }) {
  return (
    <header className="exam-header">
      {/* Breadcrumbs */}
      <div className="exam-header-breadcrumb">
        <Link to="/examination/dashboard">ExaminationOS</Link>
        {breadcrumbs.map((crumb, i) => (
          <React.Fragment key={i}>
            <span className="exam-header-breadcrumb-sep"><IconSlash /></span>
            {crumb.href ? (
              <Link to={crumb.href}>{crumb.label}</Link>
            ) : (
              <span className="exam-header-breadcrumb-current">{crumb.label}</span>
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Actions slot */}
      <div className="exam-header-actions">
        {actions}
        <button
          className="exam-btn exam-btn-ghost exam-btn-sm"
          style={{ width: 34, height: 34, padding: 0 }}
          title="Notifications"
        >
          <IconBell />
        </button>
      </div>
    </header>
  );
}
